import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { ORAdditionalInformationForm } from '@bo-client/shared/models/orderRequestWizard.model';
import { Observable, of } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, shareReplay, startWith } from 'rxjs/operators';
import {
  CalendarWeekOption,
  generateCalendarWeeks
} from '@bo-client/nap/connection-change/connection-change-detail/calendar-week-option';
import { ConnectionChangeRequestTypeEnum } from '@bo-client/shared/models/connectionChange.dto';
import { ConnectionChangeRequestTypeConfig } from '@bo-client/shared/config.model';
import { FieldConfigEnum } from '@bo-client/shared/constants/enums';
import { Observe } from '@bo-client/shared/observe.util';

@Component({
  selector: 'app-order-request-wizard-additional-info',
  templateUrl: './order-request-wizard-additional-info.component.html',
  styleUrls: ['./order-request-wizard-additional-info.component.scss']
})
export class OrderRequestWizardAdditionalInfoComponent implements OnInit {
  @Input('formGroup') additionalInfoForm: ORAdditionalInformationForm;
  @Input() selectedWishDate: Date;
  @Input() connectionChangeConfig: ConnectionChangeRequestTypeConfig;
  @Observe('connectionChangeConfig') connectionChangeConfig$: Observable<ConnectionChangeRequestTypeConfig>;

  private destroyRef = inject(DestroyRef);

  isNotOwner$ = of(false);
  wishDateOptions$: Observable<(CalendarWeekOption | null)[]>;

  ngOnInit() {
    this.wishDateOptions$ = this.connectionChangeConfig$.pipe(
      map((config) => {
        if (config.supplyAppointmentWishDateField === FieldConfigEnum.HIDDEN) return [];
        let options = generateCalendarWeeks(26, this.selectedWishDate);
        if (!(config.supplyAppointmentWishDateField === FieldConfigEnum.REQUIRED))
          options = [null, ...options];
        return options;
      })
    );
    this.isNotOwner$ = this.additionalInfoForm.controls.isOwner.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
      startWith(this.additionalInfoForm.controls.isOwner.value),
      map((value) => !value),
      shareReplay(1)
    );
    this.#initValidationListeners();
  }

  #initValidationListeners() {
    this.additionalInfoForm.controls.isOwner.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.additionalInfoForm.controls.mandate.updateValueAndValidity();
      });
  }

  protected readonly ConnectionChangeRequestTypeEnum = ConnectionChangeRequestTypeEnum;
  protected readonly FieldConfigEnum = FieldConfigEnum;
}
